import { makeStyles } from "@material-ui/core/styles";

const useLayout = makeStyles(theme => ({
    page: {
        padding: theme.spacing(2),
        display: 'flex', 
        flexWrap: 'wrap',
        justifyContent:"center"
    },
    paper: {
        width:"100%",
        padding: theme.spacing(2),
        position: 'relative'
    }
}))

export default useLayout